import styles from "../../styles/__footer.module.scss";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();
  return (
    <footer className={styles["footer"]}>
      {/* Replace the year in the (translated) footer text with the current year so it
            stays dynamic without editing translations. */}
      <p>
        {(t("footer.text") || "").replace(
          /\b\d{4}\b/,
          String(new Date().getFullYear()),
        )}
      </p>
    </footer>
  );
};

export default Footer;
